export const downloadFile = (url) => {
  const link = document.createElement("a");
  link.href = url;
  // link.setAttribute("download", "file.pdf"); //or any other extension
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
